import canAccess from "./canAccess";

export default {
  props: {
    appKey: {
      type: String,
      required: true
    },

    apps: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    currentAppName() {
      if (!(this.appKey in this.apps)) {
        if (Object.entries(this.apps).length > 0) {
          console.warn(`Invalid app name; expected one of "${Object.keys(this.apps).join("\", \"")}", received "${this.appKey}"`);
        }

        return "";
      }

      return this.apps[this.appKey].name;
    },

    filteredApps() {
      return Object.entries(this.apps)
        .filter(([key, app]) => canAccess(this.$auth.user.roles, app.excludedRoles)
          && (!(key in this.apps) || this.apps[key].enabled)) // app is not explicitly in maintenance mode
        .reduce((result, [key, app]) => ({ ...result, [key]: app }), {});
    }
  },

  methods: {
    getAppURL(app) {
      return app.legacy ? `${app.url.replace(/\/+$/, "")}/portfolios/${this.$auth.user.currentPortfolio.uid}` : app.url;
    }
  }
};
